import { render, staticRenderFns } from "./ProductModalAdd.vue?vue&type=template&id=4eb5b551&scoped=true"
import script from "./ProductModalAdd.vue?vue&type=script&lang=js"
export * from "./ProductModalAdd.vue?vue&type=script&lang=js"
import style0 from "./ProductModalAdd.vue?vue&type=style&index=0&id=4eb5b551&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb5b551",
  null
  
)

export default component.exports